var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40","height":"2","key":0}),React.createElement("rect",{"y":"8","width":"40","height":"2","key":1}),React.createElement("rect",{"y":"16","width":"40","height":"2","key":2})]);
}

Burger.defaultProps = {"width":"40","height":"18","viewBox":"0 0 40 18"};

module.exports = Burger;

Burger.default = Burger;
